import { useFocus as useFocus$1 } from '@react-aria/interactions';
import { useState, useEffect } from 'react';
import { mergeProps, useFocusRing } from 'react-aria';

/**
 * Hook for managing focus interactions.
 *
 * @param options - Options for the hook.
 */ function useFocus(options = {}) {
    const { autoFocus, disabled, isTextInput, within, ...focusEvents } = options;
    const [focused, setFocused] = useState(false);
    const { focusProps } = useFocus$1({
        isDisabled: disabled,
        ...mergeProps(focusEvents, {
            onFocus: ()=>setFocused(true),
            onBlur: ()=>setFocused(false)
        })
    });
    const { focusProps: focusRingProps, isFocusVisible } = useFocusRing({
        autoFocus,
        isTextInput,
        within
    });
    useEffect(()=>{
        disabled && setFocused(false);
    }, [
        disabled
    ]);
    return [
        {
            focused,
            focusVisible: isFocusVisible && focused
        },
        {
            focusProps: mergeProps(focusProps, focusRingProps)
        }
    ];
}

export { useFocus };
//# sourceMappingURL=use-focus.js.map
